<template>
  <section>
    {{ result }}
  </section>
</template>
<script>
export default {
  name: 'get_otoplug',

  data () {
    return {
      route_id: null,
      result: '',
    }
  },

  mounted () {
    this.api();
  },

  methods: {
    //데이터 가져오기
    api: function(){
      var url_string = window.location.href;
      var url = new URL(url_string);


      var post_data = {url: url}

      this.$axios.post('/api/api_get_otoplug', post_data).then(() => {

      });

    },
  },
}
</script>
<style>
</style>